var exports = {
  "M": "optionsButtonContainer__OnUBlp",
  "x": "notificationIndicator__vqhap3",
};

module.exports = exports;
